import { render } from "./CustomerList.vue?vue&type=template&id=4263827e"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"
script.render = render

export default script